export default "__VITE_ASSET__C8M2FnqM__"